import { html, LitElement, nothing, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { BulletType, EMPTY_SEVERITY_SCORE } from '../types';
import { WEB_COMPONENT_RISK_INCIDENT_OVERVIEW_ITEM } from '../../../webcomponents.constants';
import { RisksIncidentOverviewEvents } from '../../riskIncidentPanel/types';

@customElement(WEB_COMPONENT_RISK_INCIDENT_OVERVIEW_ITEM)
export class RiskIncidentOverviewItemWebComponent extends LitElement {
  @property({ type: String, attribute: true, reflect: true })
  name: string;

  @property({ type: String, attribute: true, reflect: true })
  icon?: string;

  @property({ type: String, attribute: true, reflect: true })
  status?: string;

  @property({ type: String, attribute: true, reflect: true })
  severityScore?: string;

  @property({ type: Number, attribute: true, reflect: true })
  typeOfBullet?: number;

  @property({ type: Number, attribute: true, reflect: true })
  type?: number;

  @property({ type: String, attribute: true, reflect: true })
  iconTooltipString?: string;

  static get styles() {
    return styles;
  }

  public render(): TemplateResult {
    const itemName = this.name ?? '...';
    let displayValue = this.severityScore;
    let setClickableClass = '';
    if (this.name) {
      setClickableClass = 'is-clickable';
    } else {
      setClickableClass = 'is-not-clickable';
    }
    if (!itemName) {
      displayValue = EMPTY_SEVERITY_SCORE;
    }
    return html`
      <div class="row fs-12">
        <div class="item-info ${setClickableClass}" @click="${this.name ? this.clickOnItemInfo : () => {}}">
          <div class="item-icon">${this.renderIcon()}</div>
          <gz-tooltip class="label-tooltip" isEllipsis tooltipText="${itemName}">
            <div class="item-name">${itemName}</div>
          </gz-tooltip>
          <div class="item-status">${this.renderStatus()}</div>
          <div class="item-score">
            <div class="item-severity-score">${displayValue}</div>
            <div class="item-bullet">${this.renderBullet()}</div>
          </div>
        </div>
      </div>
    `;
  }

  private clickOnItemInfo(): void {
    this.dispatchEvent(
      new CustomEvent(RisksIncidentOverviewEvents.VIEW_ALL_RISKS, {
        detail: {
          type: this.type ? this.type.toString() : null,
        },
        bubbles: true,
        composed: true,
      })
    );
  }

  private renderIcon(): TemplateResult {
    return this.icon
      ? html`<gz-tooltip class="icon-tooltip" tooltipText="${this.iconTooltipString}">
          <span class="icon ${this.icon}" part="icon" style="color: inherit;"></span>
        </gz-tooltip>`
      : html`<gz-tooltip class="icon-tooltip" tooltipText="${this.iconTooltipString}">
          <span class="item-icon circle-icon gray-color" />
        </gz-tooltip>`;
  }

  private renderStatus(): string | symbol {
    return this.status ?? nothing;
  }

  private renderBullet(): TemplateResult | symbol {
    return this.typeOfBullet
      ? html`<span class="cell-label has-bullet ${this.getBulletClassFromType(this.typeOfBullet)}"></span>`
      : nothing;
  }

  private getBulletClassFromType(typeOfBullet: number): string {
    let bulletClass = '';
    switch (true) {
      case typeOfBullet === BulletType.DANGER:
        bulletClass = 'bullet-danger';
        break;
      case typeOfBullet === BulletType.MEDIUM:
        bulletClass = 'bullet-orange';
        break;
      case typeOfBullet === BulletType.LOW:
        bulletClass = 'bullet-yellow';
        break;
      default:
        bulletClass = 'bullet-neutral';
        break;
    }
    return bulletClass;
  }
}
